"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var agent_1 = require("../api/agent");
var PartiesStore = /** @class */ (function () {
    function PartiesStore(rootStore) {
        var _this = this;
        this.parties = [];
        this.filteredParties = this.parties;
        this.searchterm = '';
        this.selectedPartyType = 'all';
        this.loadingParties = false;
        this.submitting = false;
        this.selectedParty = null;
        this.searchParties = function (searchterm) {
            switch (_this.selectedPartyType) {
                case 'all':
                    _this.filteredParties = _this.parties.filter(function (party) {
                        return party.name.toLowerCase().includes(searchterm);
                    });
                    break;
                case 'rp':
                    _this.filteredParties = _this.RequestingParties.filter(function (party) {
                        return party.name.toLowerCase().includes(searchterm);
                    });
                    break;
                case 'ap':
                    _this.filteredParties = _this.ApprovingParties.filter(function (party) {
                        return party.name.toLowerCase().includes(searchterm);
                    });
                    break;
                default:
                    _this.filteredParties = _this.parties;
            }
        };
        this.fetchParties = function () { return __awaiter(_this, void 0, void 0, function () {
            var parties_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingParties = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, agent_1.default.Party.list()];
                    case 2:
                        parties_1 = _a.sent();
                        mobx_1.runInAction(function () {
                            _this.parties = parties_1;
                            _this.filteredParties = parties_1;
                            _this.loadingParties = false;
                            _this.selectedPartyType = 'all';
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        mobx_1.runInAction(function () {
                            _this.loadingParties = false;
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.addParty = function (values) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, agent_1.default.Party.create(values)];
                    case 2:
                        _a.sent();
                        mobx_1.runInAction(function () {
                            _this.submitting = false;
                            _this.rootStore.modalStore.closeModal();
                            _this.fetchParties();
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.editParty = function (values) { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, agent_1.default.Party.update(values)];
                    case 2:
                        _a.sent();
                        mobx_1.runInAction(function () {
                            _this.submitting = false;
                            _this.rootStore.modalStore.closeModal();
                            _this.fetchParties();
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.deleteParty = function (uid) { return __awaiter(_this, void 0, void 0, function () {
            var error_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, agent_1.default.Party.delete(uid)];
                    case 2:
                        _a.sent();
                        mobx_1.runInAction(function () {
                            _this.submitting = false;
                            _this.rootStore.modalStore.closeModal();
                            _this.fetchParties();
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getParty = function (uid) {
            var selectedParty = _this.parties.find(function (party) {
                return party.uid === uid;
            });
            return selectedParty;
        };
        this.setSearchterm = function (searchterm) {
            _this.searchterm = searchterm;
        };
        this.setPartyType = function (type) {
            _this.selectedPartyType = type;
        };
        this.setSelectedParty = function (party) {
            _this.selectedParty = party;
        };
        this.rootStore = rootStore;
        mobx_1.makeAutoObservable(this, {
            ApprovingPartiesByQuestionField: mobx_1.computed
        });
        mobx_1.reaction(function () { return _this.searchterm; }, function (searchterm) {
            _this.searchParties(searchterm);
        });
        mobx_1.reaction(function () { return _this.selectedPartyType; }, function (selectedPartyType) {
            switch (selectedPartyType) {
                case 'all':
                    _this.filteredParties = _this.parties;
                    _this.searchterm = '';
                    break;
                case 'rp':
                    _this.filteredParties = _this.RequestingParties;
                    _this.searchterm = '';
                    break;
                case 'ap':
                    _this.filteredParties = _this.ApprovingParties;
                    _this.searchterm = '';
                    break;
                default:
                    _this.filteredParties = _this.parties;
                    _this.searchterm = '';
            }
        });
    }
    Object.defineProperty(PartiesStore.prototype, "ApprovingPartiesByQuestionField", {
        get: function () {
            var _this = this;
            var approvingParties = this.parties.filter(function (party) {
                return party.isAp && party.questionFields.includes(_this.rootStore.questionFieldStore.selectedQuestionField.value);
            });
            return approvingParties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartiesStore.prototype, "RequestingParties", {
        get: function () {
            var requestingParties = this.parties.filter(function (party) { return party.isRp; });
            return requestingParties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartiesStore.prototype, "ApprovingParties", {
        get: function () {
            var approvingParties = this.parties.filter(function (party) { return party.isAp; });
            return approvingParties;
        },
        enumerable: false,
        configurable: true
    });
    return PartiesStore;
}());
exports.default = PartiesStore;
//# sourceMappingURL=partiesStore.js.map